module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAQMAAABtzGvEAAAABlBMVEUAAABWVlajv+XeAAAAAXRSTlMAQObYZgAAABNJREFUGNNjGMTgA/MBfuzU4AUAopgHCXxyCbwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/zxyl/more_icon.png
// module id = 9SS2
// module chunks = 2